import type { FeatureManifest } from '../registry.js';
import { RushMark, railBadge, resultDue, standingStale } from './rail.js';

/**
 * CP-03 Rush Tournament (weekend, part of SCR-13): 5 fixed levels, score = stars × 1,000 −
 * seconds, one booster per level, groups of 100, exclusive decor for the top 3. The results
 * card opens once on the map after the weekend; during the weekend the map hook refreshes a
 * joined player's standing (at most hourly) and opens nothing.
 *
 * Gate: the Rush is part of SCR-13, the events hub, so it unlocks with it (`events`, level 15:
 * past the booster unlock, which its one-booster rule and ice/wrapped levels assume).
 */
export default {
  id: 'tournament',
  flag: 'tournament',
  unlock: 'events',
  online: true,
  provides: ['tournament', 'tournamentResult'],
  entry: { order: 6, icon: RushMark, label: 'feature.tournament.rail', testId: 'rail-tournament', open: 'tournament', badge: railBadge },
  mapOrder: 22,
  mapDue: (a) => a.services.sync.status !== 'offline' && ((!a.session.checked.has('tournament') && resultDue(a)) || standingStale(a)),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
